import { makeStyles } from "@material-ui/core/styles";
const useMyDashboardStyles = makeStyles({
  page: {
    display: "flex",
    justifyContent: "center",
    marginTop: "-10px",
    padding: "27px",
    gap: "32px",
    minHeight: "calc( 100vh - 140px )",
    background: "rgb(238,238,243)",
    fontWeight: 500,
    fontSize: "14.9967px",
    lineHeight: "20px",
    alignContent: "start",
    flexWrap: "wrap",
  },
  slidesArea: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "30px",
    maxWidth: "90vw",
    flexWrap: "wrap",
  },
});
export default useMyDashboardStyles;
